import axios from "axios";
import i18n from "../../../i18n";
import { handleHttpErrors } from "../../../modules/http";

const initialState = {};

export const missedSchoolReducer = (state = initialState, action) => {
  return state;
};

const addOrUpdateMissedSchool = (formData, update) => (dispatch, getState) => {
  return axios
    .put(`/api/diet/dailyentry/missedschool`, formData)
    .then(() => {
      if (update) {
        return Promise.resolve(
          i18n.t("appText.dietDiary.missedSchool.update.success")
        );
      }

      return Promise.resolve(
        i18n.t("appText.dietDiary.missedSchool.add.success")
      );
    })
    .catch((error) => {
      return handleHttpErrors(error.request?.status, {
        default: i18n.t("errorText.dietDiary.missedSchool.error"),
      });
    });
};

const removeMissedSchool = (formData) => (dispatch, getState) => {
  return axios
    .put(`/api/diet/dailyentry/missedschool`, formData)
    .then(() => {
      return Promise.resolve(
        i18n.t("appText.dietDiary.missedSchool.remove.success")
      );
    })
    .catch((error) => {
      return handleHttpErrors(error.request?.status, {
        default: i18n.t("errorText.dietDiary.missedSchool.error"),
      });
    });
};

export const mapDispatchToProps = {
  addOrUpdateMissedSchool,
  removeMissedSchool,
};
